export type PublishResult = { index: number; status: 'success' | 'error'; error?: string };

export type PublishToast =
  | { variant: 'error'; message: string; description?: string }
  | { variant: 'warning'; message: string; description?: string }
  | { variant: 'success'; message: string };

function joinErrors(results: PublishResult[]): string | undefined {
  const lines = results
    .filter((r) => r.status === 'error' && r.error)
    .map((r) => r.error!.trim());
  return lines.length ? lines.join('\n') : undefined;
}

export function resolvePublishToast(results: PublishResult[]): PublishToast {
  const successCount = results.filter((r) => r.status === 'success').length;
  const errorCount = results.filter((r) => r.status === 'error').length;
  if (successCount === 0) {
    return { variant: 'error', message: 'Публикация не удалась', description: joinErrors(results) };
  }
  if (errorCount > 0) {
    return { variant: 'warning', message: `Опубликовано ${successCount} из ${results.length}`, description: joinErrors(results) };
  }
  return { variant: 'success', message: 'Публикация завершена!' };
}
